export default {
  notify_00001: '通知',
  notify_00002: '全部通知',
  notify_00003: '年',
  notify_00004: '月',
}